// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Nps$ReactHooksTemplate = require("./Nps.res.js");
var Csat$ReactHooksTemplate = require("./csat.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Logic$ReactHooksTemplate = require("./Logic.res.js");
var Modal$ReactHooksTemplate = require("./Modal.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var Survey$ReactHooksTemplate = require("./survey.res.js");
var Welcome$ReactHooksTemplate = require("./Welcome.res.js");
var DropDown$ReactHooksTemplate = require("./DropDown.res.js");
var LongText$ReactHooksTemplate = require("./LongText.res.js");
var Question$ReactHooksTemplate = require("./Question.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");
var ThankYou$ReactHooksTemplate = require("./ThankYou.res.js");
var LogicPage$ReactHooksTemplate = require("./LogicPage.res.js");
var ShortText$ReactHooksTemplate = require("./ShortText.res.js");
var LogicGraph$ReactHooksTemplate = require("./LogicGraph.res.js");
var StarRating$ReactHooksTemplate = require("./StarRating.res.js");
var LogicalJump$ReactHooksTemplate = require("./LogicalJump.res.js");
var RatingGroup$ReactHooksTemplate = require("./RatingGroup.res.js");
var SurveyLogic$ReactHooksTemplate = require("./SurveyLogic.res.js");
var SurveyTheme$ReactHooksTemplate = require("./surveyTheme.res.js");
var CustomerInfo$ReactHooksTemplate = require("./CustomerInfo.res.js");
var MobileNumber$ReactHooksTemplate = require("./MobileNumber.res.js");
var OpinionScale$ReactHooksTemplate = require("./OpinionScale.res.js");
var SmileyRating$ReactHooksTemplate = require("./smileyRating.res.js");
var AlertComponent$ReactHooksTemplate = require("../common/AlertComponent.res.js");
var MultipleChoice$ReactHooksTemplate = require("./MultipleChoice.res.js");
var MultipleSelect$ReactHooksTemplate = require("./MultipleSelect.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var SurveyTranslations$ReactHooksTemplate = require("./SurveyTranslations.res.js");
var OrganizationProfile$ReactHooksTemplate = require("../settings/organizationProfile.res.js");
var SurveyConfiguration$ReactHooksTemplate = require("./SurveyConfiguration.res.js");
var SurveyBuilderToolbar$ReactHooksTemplate = require("./builder/SurveyBuilderToolbar.res.js");
var SurveyPreviewWrapper$ReactHooksTemplate = require("./SurveyPreviewWrapper.res.js");
var WelcomePageEditorCard$ReactHooksTemplate = require("./builder/WelcomePageEditorCard.res.js");
var QuestionPageEditorCard$ReactHooksTemplate = require("./builder/QuestionPageEditorCard.res.js");
var ThankYouPageEditorCard$ReactHooksTemplate = require("./builder/ThankYouPageEditorCard.res.js");
var SurveyBuilderLivePreview$ReactHooksTemplate = require("./builder/SurveyBuilderLivePreview.res.js");
var SurveyBuilderTypeSidebar$ReactHooksTemplate = require("./builder/SurveyBuilderTypeSidebar.res.js");
var SurveyBuilderSettingsShell$ReactHooksTemplate = require("./builder/SurveyBuilderSettingsShell.res.js");

var bhimaQuestiontemplate = "\n  <div class=\"h-full\">\n    <div class=\"pt-40-px w-full pb-20-px absolute\">\n      <div id=\"logo\">\n        logo\n      </div>\n    </div>\n    <div class=\"max-w-840-px mx-auto px-60-px min-h-screen flex flex-col\n    justify-center pt-160-px small:pt-142-px\">\n\n      <div class=\"pb-100-px pt-5\">\n        <div id=\"question\">question</div>\n      </div>\n      <div class=\"flex w-full justify-center items-center gap-4 mb-8\">\n        <div id=\"previousButton\"></div>\n        <div id=\"nextButton\"></div>\n      </div>\n    </div>\n  </div>\n";

var defaultQuestiontemplate = "\n  <div class=\"h-full\">\n    <div class=\"pt-40-px w-full pb-20-px\">\n      <div id=\"logo\">\n        logo\n      </div>\n    </div>\n    <div class=\"max-w-960-px mx-auto p-30-px min-h-screen flex flex-col\n    justify-center\">\n      <div class=\"pb-60-px\">\n        <div id=\"question\">question</div>\n      </div>\n      <div class=\"flex w-full justify-center items-center gap-4 mb-8\">\n        <div id=\"previousButton\"></div>\n        <div id=\"nextButton\"></div>\n      </div>\n    </div>\n  </div>\n";

var defaultQuestionBuildertemplate = "\n  <div>\n    <div>\n      <div>\n        <div id=\"question\">question</div>\n      </div>\n    </div>\n  </div>\n";

var questiontemplates = {
  bhima: bhimaQuestiontemplate,
  default: defaultQuestiontemplate
};

var builderPreviewQuestionTemplates = {
  bhima: defaultQuestionBuildertemplate,
  default: defaultQuestionBuildertemplate
};

var questionBuilderTemplates = {
  bhima: bhimaQuestiontemplate,
  default: defaultQuestionBuildertemplate
};

function formatQuestionTypeLabel(categoryType) {
  switch (categoryType) {
    case "Csat" :
        return "CSAT";
    case "DropDown" :
        return "Drop Down";
    case "LongText" :
        return "Long Text";
    case "MobileNumber" :
        return "Mobile Number";
    case "MultipleChoice" :
        return "Multiple Choice";
    case "MultipleSelect" :
        return "Multiple Select";
    case "Nps" :
        return "NPS";
    case "OpinionScale" :
        return "Opinion Scale";
    case "RatingGroup" :
        return "Rating Group";
    case "ShortText" :
        return "Short Text";
    case "SmileyRating" :
        return "Smiley Rating";
    case "StarRating" :
        return "Star Rating";
    case "thank_you" :
        return "Thank You";
    case "welcome" :
        return "Welcome";
    default:
      return categoryType;
  }
}

function questionTypeIcon(categoryType) {
  switch (categoryType) {
    case "LongText" :
        return Image$ReactHooksTemplate.longText;
    case "MultipleChoice" :
    case "MultipleSelect" :
        return Image$ReactHooksTemplate.radioButtonChecked;
    case "Nps" :
    case "OpinionScale" :
        return Image$ReactHooksTemplate.opinionScale;
    case "MobileNumber" :
    case "ShortText" :
        return Image$ReactHooksTemplate.shortText;
    case "RatingGroup" :
    case "SmileyRating" :
    case "StarRating" :
        return Image$ReactHooksTemplate.rating;
    case "thank_you" :
    case "welcome" :
        return Image$ReactHooksTemplate.welcomeThankyou;
    default:
      return Image$ReactHooksTemplate.defaultQuestion;
  }
}

function decodeSurvey(json) {
  var name = Json_decode.field("survey", (function (param) {
          return Json_decode.field("name", Json_decode.string, param);
        }), json);
  var logo = Json_decode.field("survey", (function (param) {
          return Json_decode.field("logo", (function (param) {
                        return Json_decode.optional(Json_decode.string, param);
                      }), param);
        }), json);
  var questionFromJson = Question$ReactHooksTemplate.fromJson(json);
  var theme = Json_decode.field("survey", (function (param) {
          return Json_decode.field("theme", SurveyTheme$ReactHooksTemplate.decode, param);
        }), json);
  var thankYouList = Json_decode.field("survey", (function (param) {
          return Json_decode.field("thank_yous", (function (param) {
                        return Json_decode.list(ThankYou$ReactHooksTemplate.fromJson, param);
                      }), param);
        }), json);
  var surveyLanguages = Json_decode.field("survey", (function (param) {
          return Json_decode.field("survey_languages", (function (param) {
                        return Json_decode.list(SurveyLanguage$ReactHooksTemplate.fromJson, param);
                      }), param);
        }), json);
  return [
          name,
          logo,
          theme,
          Welcome$ReactHooksTemplate.fromJson(json),
          questionFromJson,
          LogicalJump$ReactHooksTemplate.fromJson(questionFromJson, json),
          thankYouList,
          surveyLanguages
        ];
}

function addQuestionsToGraph(questions) {
  return List.fold_left((function (graph, item) {
                return LogicGraph$ReactHooksTemplate.addNode({
                            TAG: "Question",
                            _0: item
                          }, graph);
              }), LogicGraph$ReactHooksTemplate.empty(), questions);
}

function reducer(state, action) {
  if (typeof action !== "object") {
    switch (action) {
      case "RemoveWelcomeEditorBlock" :
          var welcome = Survey$ReactHooksTemplate.welcome(state.survey);
          var survey;
          if (welcome !== undefined) {
            var match = Welcome$ReactHooksTemplate.id(Caml_option.valFromOption(welcome));
            survey = match !== undefined ? Survey$ReactHooksTemplate.setDeletedWelcome(state.survey, Survey$ReactHooksTemplate.welcome(state.survey)) : state.survey;
          } else {
            survey = state.survey;
          }
          var match$1 = Survey$ReactHooksTemplate.questions(state.survey);
          var nextQuestion;
          if (match$1) {
            nextQuestion = {
              TAG: "Question",
              _0: match$1.hd
            };
          } else {
            var match$2 = Survey$ReactHooksTemplate.thankYouList(state.survey);
            nextQuestion = match$2 ? ({
                  TAG: "ThankYou",
                  _0: match$2.hd
                }) : "Empty";
          }
          if (typeof nextQuestion === "object") {
            switch (nextQuestion.TAG) {
              case "Welcome" :
                  break;
              case "ThankYou" :
                  var x = nextQuestion._0;
                  var newrecord = Caml_obj.obj_dup(state);
                  newrecord.builderPreview = {
                    TAG: "ThankYou",
                    _0: Caml_option.some(x)
                  };
                  newrecord.selectedId = ThankYou$ReactHooksTemplate.uuid(x);
                  newrecord.selected = ThankYou$ReactHooksTemplate.categoryType;
                  newrecord.survey = Survey$ReactHooksTemplate.setWelcome(survey, undefined);
                  return newrecord;
              case "Question" :
                  var x$1 = nextQuestion._0;
                  var newrecord$1 = Caml_obj.obj_dup(state);
                  newrecord$1.builderPreview = {
                    TAG: "QuestionPage",
                    _0: questionBuilderTemplates,
                    _1: x$1,
                    _2: CustomerInfo$ReactHooksTemplate.empty()
                  };
                  newrecord$1.selectedId = Question$ReactHooksTemplate.uuid(x$1);
                  newrecord$1.selected = Question$ReactHooksTemplate.categoryType(x$1);
                  newrecord$1.survey = Survey$ReactHooksTemplate.setWelcome(survey, undefined);
                  return newrecord$1;
              
            }
          }
          var newrecord$2 = Caml_obj.obj_dup(state);
          newrecord$2.builderPreview = "Empty";
          newrecord$2.selectedId = RandomId$ReactHooksTemplate.generate();
          newrecord$2.selected = Welcome$ReactHooksTemplate.categoryType;
          newrecord$2.survey = Survey$ReactHooksTemplate.setWelcome(survey, undefined);
          return newrecord$2;
      case "PreviewWelcome" :
          var newrecord$3 = Caml_obj.obj_dup(state);
          newrecord$3.builderPreview = {
            TAG: "Welcome",
            _0: Survey$ReactHooksTemplate.welcome(state.survey)
          };
          return newrecord$3;
      case "TogglePreview" :
          var newrecord$4 = Caml_obj.obj_dup(state);
          newrecord$4.showPreview = !state.showPreview;
          return newrecord$4;
      case "ToggleAddQuestion" :
          var newrecord$5 = Caml_obj.obj_dup(state);
          newrecord$5.showAddQuestions = !state.showAddQuestions;
          return newrecord$5;
      case "ToggleSurveyConfiguration" :
          var newrecord$6 = Caml_obj.obj_dup(state);
          newrecord$6.showConfigurations = !state.showConfigurations;
          return newrecord$6;
      case "AddLogicalJump" :
          var newrecord$7 = Caml_obj.obj_dup(state);
          newrecord$7.logicalJumpGroup = LogicalJump$ReactHooksTemplate.addToGroup(LogicalJump$ReactHooksTemplate.empty(), state.logicalJumpGroup);
          return newrecord$7;
      case "InvalidName" :
          var newrecord$8 = Caml_obj.obj_dup(state);
          newrecord$8.nameInvalid = true;
          return newrecord$8;
      case "ValidName" :
          var newrecord$9 = Caml_obj.obj_dup(state);
          newrecord$9.nameInvalid = false;
          return newrecord$9;
      case "RemoveNotification" :
          var newrecord$10 = Caml_obj.obj_dup(state);
          newrecord$10.notification = undefined;
          return newrecord$10;
      case "ResetPagination" :
          var match$3 = Survey$ReactHooksTemplate.paginationSettings(state.survey);
          var newSetting = match$3 !== undefined && typeof match$3 === "object" ? undefined : ({
                TAG: "Uniform",
                _0: 1
              });
          var newSurvey = Survey$ReactHooksTemplate.setPageMappings(Survey$ReactHooksTemplate.setPaginationSettings(state.survey, newSetting), /* [] */0);
          var newrecord$11 = Caml_obj.obj_dup(state);
          newrecord$11.paginationReset = true;
          newrecord$11.survey = newSurvey;
          return newrecord$11;
      
    }
  } else {
    switch (action.TAG) {
      case "UpdateSurvey" :
          var newrecord$12 = Caml_obj.obj_dup(state);
          newrecord$12.survey = action._0;
          return newrecord$12;
      case "SetClient" :
          var newrecord$13 = Caml_obj.obj_dup(state);
          newrecord$13.client = action._0;
          return newrecord$13;
      case "AddEditorBlock" :
          var questionOrPage = action._1;
          var index = action._0;
          switch (questionOrPage.TAG) {
            case "Welcome" :
                var welcome$1 = questionOrPage._0;
                var newrecord$14 = Caml_obj.obj_dup(state);
                newrecord$14.builderPreview = {
                  TAG: "Welcome",
                  _0: Caml_option.some(welcome$1)
                };
                newrecord$14.selected = Welcome$ReactHooksTemplate.categoryType;
                newrecord$14.survey = Survey$ReactHooksTemplate.setWelcome(state.survey, Caml_option.some(welcome$1));
                return newrecord$14;
            case "ThankYou" :
                var thankYou = questionOrPage._0;
                var match$4 = Belt_List.splitAt(Survey$ReactHooksTemplate.thankYouList(state.survey), index);
                var thankYouList = match$4 !== undefined ? Belt_List.concatMany([
                        match$4[0],
                        {
                          hd: thankYou,
                          tl: /* [] */0
                        },
                        match$4[1]
                      ]) : Belt_List.concat(Survey$ReactHooksTemplate.thankYouList(state.survey), {
                        hd: thankYou,
                        tl: /* [] */0
                      });
                var addedThankYouEl = List.nth(thankYouList, index);
                var newrecord$15 = Caml_obj.obj_dup(state);
                newrecord$15.builderPreview = {
                  TAG: "ThankYou",
                  _0: Caml_option.some(addedThankYouEl)
                };
                newrecord$15.selectedId = ThankYou$ReactHooksTemplate.uuid(addedThankYouEl);
                newrecord$15.selected = ThankYou$ReactHooksTemplate.categoryType;
                newrecord$15.survey = Survey$ReactHooksTemplate.setThankYouList(state.survey, thankYouList);
                return newrecord$15;
            case "Question" :
                var question = questionOrPage._0;
                var match$5 = Belt_List.splitAt(Survey$ReactHooksTemplate.questions(state.survey), index);
                var questions = match$5 !== undefined ? Belt_List.concatMany([
                        match$5[0],
                        {
                          hd: question,
                          tl: /* [] */0
                        },
                        match$5[1]
                      ]) : Belt_List.concat(Survey$ReactHooksTemplate.questions(state.survey), {
                        hd: question,
                        tl: /* [] */0
                      });
                var match$6 = Survey$ReactHooksTemplate.paginationSettings(state.survey);
                var match$7;
                var exit = 0;
                if (match$6 !== undefined && typeof match$6 !== "object" && match$6 !== "SinglePage") {
                  match$7 = [
                    Survey$ReactHooksTemplate.setPageMappings(Survey$ReactHooksTemplate.setPaginationSettings(Survey$ReactHooksTemplate.setQuestions(state.survey, questions), {
                              TAG: "Uniform",
                              _0: 1
                            }), /* [] */0),
                    true
                  ];
                } else {
                  exit = 1;
                }
                if (exit === 1) {
                  match$7 = [
                    Survey$ReactHooksTemplate.setQuestions(state.survey, questions),
                    false
                  ];
                }
                var graph$p = SurveyLogic$ReactHooksTemplate.addLogicToEdges(questions, SurveyLogic$ReactHooksTemplate.changeEdges(Survey$ReactHooksTemplate.name(state.survey), questions, Survey$ReactHooksTemplate.thankYouList(state.survey), addQuestionsToGraph(questions)));
                var addedQuestionEl = List.nth(questions, index);
                var newrecord$16 = Caml_obj.obj_dup(state);
                newrecord$16.paginationReset = match$7[1] ? true : state.paginationReset;
                newrecord$16.graph = graph$p;
                newrecord$16.builderPreview = {
                  TAG: "QuestionPage",
                  _0: questionBuilderTemplates,
                  _1: addedQuestionEl,
                  _2: CustomerInfo$ReactHooksTemplate.empty()
                };
                newrecord$16.selectedId = Question$ReactHooksTemplate.uuid(addedQuestionEl);
                newrecord$16.selected = Question$ReactHooksTemplate.categoryType(question);
                newrecord$16.survey = match$7[0];
                return newrecord$16;
            
          }
          break;
      case "RemoveThankYouEditorBlock" :
          var logics = action._2;
          var thankYou$1 = action._1;
          var index$1 = action._0;
          var match$8 = ThankYou$ReactHooksTemplate.id(thankYou$1);
          var deletedThankYouList = match$8 !== undefined ? Belt_List.concat(Survey$ReactHooksTemplate.deletedThankYouList(state.survey), {
                  hd: thankYou$1,
                  tl: /* [] */0
                }) : Survey$ReactHooksTemplate.deletedThankYouList(state.survey);
          var logics$p = Belt_List.keep(Survey$ReactHooksTemplate.logics(state.survey), (function (x) {
                  return !List.exists((function (y) {
                                return Caml_obj.equal(y, x);
                              }), logics);
                }));
          var deletedLogics = Belt_List.concat(Survey$ReactHooksTemplate.deletedLogics(state.survey), logics);
          var x$2 = Belt_List.get(Survey$ReactHooksTemplate.thankYouList(state.survey), index$1 + 1 | 0);
          var nextQuestion$1;
          if (x$2 !== undefined) {
            nextQuestion$1 = {
              TAG: "ThankYou",
              _0: Caml_option.valFromOption(x$2)
            };
          } else {
            var x$3 = Belt_List.get(Survey$ReactHooksTemplate.thankYouList(state.survey), index$1 - 1 | 0);
            if (x$3 !== undefined) {
              nextQuestion$1 = {
                TAG: "ThankYou",
                _0: Caml_option.valFromOption(x$3)
              };
            } else {
              var length = Belt_List.length(Survey$ReactHooksTemplate.questions(state.survey));
              var match$9 = Survey$ReactHooksTemplate.questions(state.survey);
              if (match$9) {
                var x$4 = Belt_List.get(Survey$ReactHooksTemplate.questions(state.survey), length - 1 | 0);
                if (x$4 !== undefined) {
                  nextQuestion$1 = {
                    TAG: "Question",
                    _0: x$4
                  };
                } else {
                  var x$5 = Survey$ReactHooksTemplate.welcome(state.survey);
                  nextQuestion$1 = x$5 !== undefined ? ({
                        TAG: "Welcome",
                        _0: Caml_option.valFromOption(x$5)
                      }) : "Empty";
                }
              } else {
                var x$6 = Survey$ReactHooksTemplate.welcome(state.survey);
                nextQuestion$1 = x$6 !== undefined ? ({
                      TAG: "Welcome",
                      _0: Caml_option.valFromOption(x$6)
                    }) : "Empty";
              }
            }
          }
          if (typeof nextQuestion$1 !== "object") {
            var newrecord$17 = Caml_obj.obj_dup(state);
            newrecord$17.builderPreview = "Empty";
            newrecord$17.selectedId = RandomId$ReactHooksTemplate.generate();
            newrecord$17.selected = Welcome$ReactHooksTemplate.categoryType;
            newrecord$17.survey = Survey$ReactHooksTemplate.setLogics(Survey$ReactHooksTemplate.setDeletedLogics(Survey$ReactHooksTemplate.setDeletedThankYouList(Survey$ReactHooksTemplate.setThankYouList(state.survey, Belt_List.keep(Survey$ReactHooksTemplate.thankYouList(state.survey), (function (x) {
                                    return Caml_obj.notequal(ThankYou$ReactHooksTemplate.uuid(x), ThankYou$ReactHooksTemplate.uuid(thankYou$1));
                                  }))), deletedThankYouList), deletedLogics), logics$p);
            return newrecord$17;
          }
          switch (nextQuestion$1.TAG) {
            case "Welcome" :
                var newrecord$18 = Caml_obj.obj_dup(state);
                newrecord$18.selected = Welcome$ReactHooksTemplate.categoryType;
                newrecord$18.survey = Survey$ReactHooksTemplate.setLogics(Survey$ReactHooksTemplate.setDeletedLogics(Survey$ReactHooksTemplate.setDeletedThankYouList(Survey$ReactHooksTemplate.setThankYouList(state.survey, Belt_List.keep(Survey$ReactHooksTemplate.thankYouList(state.survey), (function (x) {
                                        return Caml_obj.notequal(ThankYou$ReactHooksTemplate.uuid(x), ThankYou$ReactHooksTemplate.uuid(thankYou$1));
                                      }))), deletedThankYouList), deletedLogics), logics$p);
                return newrecord$18;
            case "ThankYou" :
                var x$7 = nextQuestion$1._0;
                var newrecord$19 = Caml_obj.obj_dup(state);
                newrecord$19.builderPreview = {
                  TAG: "ThankYou",
                  _0: Caml_option.some(x$7)
                };
                newrecord$19.selectedId = ThankYou$ReactHooksTemplate.uuid(x$7);
                newrecord$19.selected = ThankYou$ReactHooksTemplate.categoryType;
                newrecord$19.survey = Survey$ReactHooksTemplate.setLogics(Survey$ReactHooksTemplate.setDeletedLogics(Survey$ReactHooksTemplate.setDeletedThankYouList(Survey$ReactHooksTemplate.setThankYouList(state.survey, Belt_List.keep(Survey$ReactHooksTemplate.thankYouList(state.survey), (function (x) {
                                        return Caml_obj.notequal(ThankYou$ReactHooksTemplate.uuid(x), ThankYou$ReactHooksTemplate.uuid(thankYou$1));
                                      }))), deletedThankYouList), deletedLogics), logics$p);
                return newrecord$19;
            case "Question" :
                var x$8 = nextQuestion$1._0;
                var newrecord$20 = Caml_obj.obj_dup(state);
                newrecord$20.builderPreview = {
                  TAG: "QuestionPage",
                  _0: questionBuilderTemplates,
                  _1: x$8,
                  _2: CustomerInfo$ReactHooksTemplate.empty()
                };
                newrecord$20.selectedId = Question$ReactHooksTemplate.uuid(x$8);
                newrecord$20.selected = Question$ReactHooksTemplate.categoryType(x$8);
                newrecord$20.survey = Survey$ReactHooksTemplate.setLogics(Survey$ReactHooksTemplate.setDeletedLogics(Survey$ReactHooksTemplate.setDeletedThankYouList(Survey$ReactHooksTemplate.setThankYouList(state.survey, Belt_List.keep(Survey$ReactHooksTemplate.thankYouList(state.survey), (function (x) {
                                        return Caml_obj.notequal(ThankYou$ReactHooksTemplate.uuid(x), ThankYou$ReactHooksTemplate.uuid(thankYou$1));
                                      }))), deletedThankYouList), deletedLogics), logics$p);
                return newrecord$20;
            
          }
      case "RemoveQuestionEditorBlock" :
          var logics$1 = action._2;
          var question$1 = action._1;
          var index$2 = action._0;
          var deletedLogics$1 = Belt_List.concat(Survey$ReactHooksTemplate.deletedLogics(state.survey), logics$1);
          var logics$p$1 = List.length(logics$1) !== 0 ? Belt_List.keep(Survey$ReactHooksTemplate.logics(state.survey), (function (x) {
                    return !List.exists((function (y) {
                                  return Caml_obj.equal(y, x);
                                }), logics$1);
                  })) : Survey$ReactHooksTemplate.logics(state.survey);
          var match$10 = Question$ReactHooksTemplate.id(question$1);
          var deletedQuestions = match$10 !== undefined ? Belt_List.concat(Survey$ReactHooksTemplate.deletedQuestions(state.survey), {
                  hd: question$1,
                  tl: /* [] */0
                }) : Survey$ReactHooksTemplate.deletedQuestions(state.survey);
          var questions$p = Belt_List.keep(Survey$ReactHooksTemplate.questions(state.survey), (function (x) {
                  return Caml_obj.notequal(Question$ReactHooksTemplate.uuid(x), Question$ReactHooksTemplate.uuid(question$1));
                }));
          var graph$p$1 = SurveyLogic$ReactHooksTemplate.addLogicToEdges(questions$p, SurveyLogic$ReactHooksTemplate.changeEdges(Survey$ReactHooksTemplate.name(state.survey), questions$p, Survey$ReactHooksTemplate.thankYouList(state.survey), addQuestionsToGraph(questions$p)));
          var x$9 = Belt_List.get(Survey$ReactHooksTemplate.questions(state.survey), index$2 + 1 | 0);
          var nextQuestion$2;
          if (x$9 !== undefined) {
            nextQuestion$2 = {
              TAG: "Question",
              _0: x$9
            };
          } else {
            var match$11 = Survey$ReactHooksTemplate.thankYouList(state.survey);
            if (match$11) {
              nextQuestion$2 = {
                TAG: "ThankYou",
                _0: match$11.hd
              };
            } else {
              var x$10 = Belt_List.get(Survey$ReactHooksTemplate.questions(state.survey), index$2 - 1 | 0);
              if (x$10 !== undefined) {
                nextQuestion$2 = {
                  TAG: "Question",
                  _0: x$10
                };
              } else {
                var x$11 = Survey$ReactHooksTemplate.welcome(state.survey);
                nextQuestion$2 = x$11 !== undefined ? ({
                      TAG: "Welcome",
                      _0: Caml_option.valFromOption(x$11)
                    }) : "Empty";
              }
            }
          }
          if (typeof nextQuestion$2 !== "object") {
            var newrecord$21 = Caml_obj.obj_dup(state);
            newrecord$21.graph = graph$p$1;
            newrecord$21.builderPreview = "Empty";
            newrecord$21.selectedId = RandomId$ReactHooksTemplate.generate();
            newrecord$21.selected = Welcome$ReactHooksTemplate.categoryType;
            newrecord$21.survey = Survey$ReactHooksTemplate.setDeletedLogics(Survey$ReactHooksTemplate.setLogics(Survey$ReactHooksTemplate.setDeletedQuestions(Survey$ReactHooksTemplate.setQuestions(state.survey, questions$p), deletedQuestions), logics$p$1), deletedLogics$1);
            return newrecord$21;
          }
          switch (nextQuestion$2.TAG) {
            case "Welcome" :
                var newrecord$22 = Caml_obj.obj_dup(state);
                newrecord$22.graph = graph$p$1;
                newrecord$22.selected = Welcome$ReactHooksTemplate.categoryType;
                newrecord$22.survey = Survey$ReactHooksTemplate.setDeletedLogics(Survey$ReactHooksTemplate.setLogics(Survey$ReactHooksTemplate.setDeletedQuestions(Survey$ReactHooksTemplate.setQuestions(state.survey, questions$p), deletedQuestions), logics$p$1), deletedLogics$1);
                return newrecord$22;
            case "ThankYou" :
                var x$12 = nextQuestion$2._0;
                var newrecord$23 = Caml_obj.obj_dup(state);
                newrecord$23.graph = graph$p$1;
                newrecord$23.builderPreview = {
                  TAG: "ThankYou",
                  _0: Caml_option.some(x$12)
                };
                newrecord$23.selectedId = ThankYou$ReactHooksTemplate.uuid(x$12);
                newrecord$23.selected = ThankYou$ReactHooksTemplate.categoryType;
                newrecord$23.survey = Survey$ReactHooksTemplate.setDeletedLogics(Survey$ReactHooksTemplate.setLogics(Survey$ReactHooksTemplate.setDeletedQuestions(Survey$ReactHooksTemplate.setQuestions(state.survey, questions$p), deletedQuestions), logics$p$1), deletedLogics$1);
                return newrecord$23;
            case "Question" :
                var x$13 = nextQuestion$2._0;
                var newrecord$24 = Caml_obj.obj_dup(state);
                newrecord$24.graph = graph$p$1;
                newrecord$24.builderPreview = {
                  TAG: "QuestionPage",
                  _0: questionBuilderTemplates,
                  _1: x$13,
                  _2: CustomerInfo$ReactHooksTemplate.empty()
                };
                newrecord$24.selectedId = Question$ReactHooksTemplate.uuid(x$13);
                newrecord$24.selected = Question$ReactHooksTemplate.categoryType(x$13);
                newrecord$24.survey = Survey$ReactHooksTemplate.setDeletedLogics(Survey$ReactHooksTemplate.setLogics(Survey$ReactHooksTemplate.setDeletedQuestions(Survey$ReactHooksTemplate.setQuestions(state.survey, questions$p), deletedQuestions), logics$p$1), deletedLogics$1);
                return newrecord$24;
            
          }
      case "SetSelected" :
          var newrecord$25 = Caml_obj.obj_dup(state);
          newrecord$25.selected = action._0;
          return newrecord$25;
      case "SetSelectedId" :
          var newrecord$26 = Caml_obj.obj_dup(state);
          newrecord$26.selectedId = action._0;
          return newrecord$26;
      case "UpdateWelcome" :
          var welcome$2 = action._0;
          var newrecord$27 = Caml_obj.obj_dup(state);
          newrecord$27.builderPreview = {
            TAG: "Welcome",
            _0: Caml_option.some(welcome$2)
          };
          newrecord$27.survey = Survey$ReactHooksTemplate.setWelcome(state.survey, Caml_option.some(welcome$2));
          return newrecord$27;
      case "UpdateThankYou" :
          var thankYou$2 = action._0;
          var thankYouList$p = Belt_List.map(Survey$ReactHooksTemplate.thankYouList(state.survey), (function (x) {
                  if (Caml_obj.equal(ThankYou$ReactHooksTemplate.uuid(x), ThankYou$ReactHooksTemplate.uuid(thankYou$2))) {
                    return thankYou$2;
                  } else {
                    return x;
                  }
                }));
          var newrecord$28 = Caml_obj.obj_dup(state);
          newrecord$28.builderPreview = {
            TAG: "ThankYou",
            _0: Caml_option.some(thankYou$2)
          };
          newrecord$28.survey = Survey$ReactHooksTemplate.setThankYouList(state.survey, thankYouList$p);
          return newrecord$28;
      case "UpdateQuestion" :
          var question$2 = action._0;
          var questions$p$1 = Belt_List.map(Survey$ReactHooksTemplate.questions(state.survey), (function (x) {
                  if (Caml_obj.equal(Question$ReactHooksTemplate.uuid(x), Question$ReactHooksTemplate.uuid(question$2))) {
                    return question$2;
                  } else {
                    return x;
                  }
                }));
          var graph$p$2 = SurveyLogic$ReactHooksTemplate.addLogicToEdges(questions$p$1, SurveyLogic$ReactHooksTemplate.changeEdges(Survey$ReactHooksTemplate.name(state.survey), questions$p$1, Survey$ReactHooksTemplate.thankYouList(state.survey), addQuestionsToGraph(questions$p$1)));
          var newrecord$29 = Caml_obj.obj_dup(state);
          newrecord$29.graph = graph$p$2;
          newrecord$29.builderPreview = {
            TAG: "QuestionPage",
            _0: questionBuilderTemplates,
            _1: question$2,
            _2: CustomerInfo$ReactHooksTemplate.empty()
          };
          newrecord$29.survey = Survey$ReactHooksTemplate.setQuestions(state.survey, questions$p$1);
          return newrecord$29;
      case "PreviewQuestion" :
          var newrecord$30 = Caml_obj.obj_dup(state);
          newrecord$30.builderPreview = {
            TAG: "QuestionPage",
            _0: questionBuilderTemplates,
            _1: action._0,
            _2: CustomerInfo$ReactHooksTemplate.empty()
          };
          return newrecord$30;
      case "PreviewThankYou" :
          var newrecord$31 = Caml_obj.obj_dup(state);
          newrecord$31.builderPreview = {
            TAG: "ThankYou",
            _0: Caml_option.some(action._0)
          };
          return newrecord$31;
      case "SetShowAddQuestions" :
          var newrecord$32 = Caml_obj.obj_dup(state);
          newrecord$32.showAddQuestions = action._0;
          return newrecord$32;
      case "ShowWelcomeThankYou" :
          var newrecord$33 = Caml_obj.obj_dup(state);
          newrecord$33.showThankyou = action._1;
          newrecord$33.showWelcome = action._0;
          return newrecord$33;
      case "AddLogo" :
          var newrecord$34 = Caml_obj.obj_dup(state);
          newrecord$34.survey = Survey$ReactHooksTemplate.setLogo(state.survey, action._0);
          return newrecord$34;
      case "ReplaceLogic" :
          var newrecord$35 = Caml_obj.obj_dup(state);
          newrecord$35.logicalJumpGroup = LogicalJump$ReactHooksTemplate.replaceInGroup(action._0, state.logicalJumpGroup);
          return newrecord$35;
      case "ChangeLanguage" :
          var newrecord$36 = Caml_obj.obj_dup(state);
          newrecord$36.language = action._0;
          return newrecord$36;
      case "AddNotification" :
          var newrecord$37 = Caml_obj.obj_dup(state);
          newrecord$37.notification = action._0;
          return newrecord$37;
      case "SetOutsideClick" :
          var newrecord$38 = Caml_obj.obj_dup(state);
          newrecord$38.outsideClick = action._0;
          return newrecord$38;
      case "SetAddQuestionBelow" :
          var newrecord$39 = Caml_obj.obj_dup(state);
          newrecord$39.addQuestionBelow = action._0;
          return newrecord$39;
      case "SetAddThankYouToTop" :
          var newrecord$40 = Caml_obj.obj_dup(state);
          newrecord$40.addThankYouToTop = action._0;
          return newrecord$40;
      case "SetToBeAddedBelowIndex" :
          var newrecord$41 = Caml_obj.obj_dup(state);
          newrecord$41.toBeAddedBelowIndex = action._0;
          return newrecord$41;
      case "SetSelectedEditor" :
          var newrecord$42 = Caml_obj.obj_dup(state);
          newrecord$42.selectedEditor = action._0;
          return newrecord$42;
      case "SetPopUp" :
          var popUp = action._0;
          var newrecord$43 = Caml_obj.obj_dup(state);
          newrecord$43.popUp = popUp;
          if (popUp === undefined) {
            return newrecord$43;
          }
          if (typeof popUp === "object") {
            return newrecord$43;
          }
          if (popUp !== "PaginationReset") {
            return newrecord$43;
          }
          var newrecord$44 = Caml_obj.obj_dup(newrecord$43);
          newrecord$44.paginationReset = false;
          return newrecord$44;
      case "UpdateBuilderPreview" :
          var survey$1 = action._0;
          var thankYou$3 = state.builderPreview;
          if (typeof thankYou$3 === "object") {
            switch (thankYou$3.TAG) {
              case "Welcome" :
                  break;
              case "QuestionPage" :
                  var question$3 = thankYou$3._1;
                  var question$p = question$3 !== undefined ? Belt_List.head(Belt_List.keep(Survey$ReactHooksTemplate.questions(survey$1), (function (x) {
                                return Caml_obj.equal(Question$ReactHooksTemplate.uuid(x), Question$ReactHooksTemplate.uuid(question$3));
                              }))) : Belt_List.head(Survey$ReactHooksTemplate.questions(survey$1));
                  var newrecord$45 = Caml_obj.obj_dup(state);
                  newrecord$45.builderPreview = {
                    TAG: "QuestionPage",
                    _0: thankYou$3._0,
                    _1: question$p,
                    _2: thankYou$3._2
                  };
                  return newrecord$45;
              case "ThankYou" :
                  var thankYou$4 = thankYou$3._0;
                  var thankYou$p;
                  if (thankYou$4 !== undefined) {
                    var thankYou$5 = Caml_option.valFromOption(thankYou$4);
                    thankYou$p = Belt_List.head(Belt_List.keep(Survey$ReactHooksTemplate.thankYouList(survey$1), (function (x) {
                                return Caml_obj.equal(ThankYou$ReactHooksTemplate.uuid(x), ThankYou$ReactHooksTemplate.uuid(thankYou$5));
                              })));
                  } else {
                    thankYou$p = Belt_List.head(Survey$ReactHooksTemplate.thankYouList(survey$1));
                  }
                  var newrecord$46 = Caml_obj.obj_dup(state);
                  newrecord$46.builderPreview = {
                    TAG: "ThankYou",
                    _0: thankYou$p
                  };
                  return newrecord$46;
              
            }
          }
          var newrecord$47 = Caml_obj.obj_dup(state);
          newrecord$47.builderPreview = {
            TAG: "Welcome",
            _0: Survey$ReactHooksTemplate.welcome(state.survey)
          };
          return newrecord$47;
      case "SetBulkTriggerToken" :
          var newrecord$48 = Caml_obj.obj_dup(state);
          newrecord$48.bulkTriggerToken = action._0;
          return newrecord$48;
      case "SetShowTokenModal" :
          var newrecord$49 = Caml_obj.obj_dup(state);
          newrecord$49.showTokenModal = action._0;
          return newrecord$49;
      
    }
  }
}

function SurveyForm(props) {
  var projectId = props.projectId;
  var survey = props.survey;
  var initialState = survey !== undefined ? ({
        survey: survey,
        selected: Welcome$ReactHooksTemplate.categoryType,
        selectedId: RandomId$ReactHooksTemplate.generate(),
        nameInvalid: Survey$ReactHooksTemplate.name(survey).length === 0,
        showPreview: false,
        showSurveyNameInput: false,
        showAddQuestions: false,
        logicalJumpGroup: LogicalJump$ReactHooksTemplate.makeGroup(),
        builderPreview: {
          TAG: "Welcome",
          _0: Survey$ReactHooksTemplate.welcome(survey)
        },
        graph: SurveyLogic$ReactHooksTemplate.addLogicToEdges(Survey$ReactHooksTemplate.questions(survey), SurveyLogic$ReactHooksTemplate.changeEdges(Survey$ReactHooksTemplate.name(survey), Survey$ReactHooksTemplate.questions(survey), Survey$ReactHooksTemplate.thankYouList(survey), addQuestionsToGraph(Survey$ReactHooksTemplate.questions(survey)))),
        client: OrganizationProfile$ReactHooksTemplate.empty(),
        language: SurveyLanguage$ReactHooksTemplate.default,
        surveyLanguages: /* [] */0,
        notification: undefined,
        showConfigurations: false,
        outsideClick: true,
        showWelcome: true,
        showThankyou: true,
        addQuestionBelow: false,
        toBeAddedBelowIndex: 0,
        addThankYouToTop: false,
        selectedEditor: "QuestionsEditor",
        popUp: undefined,
        bulkTriggerToken: undefined,
        showTokenModal: false,
        paginationSettings: {
          TAG: "Uniform",
          _0: 1
        },
        paginationReset: false
      }) : ({
        survey: Survey$ReactHooksTemplate.empty(),
        selected: Welcome$ReactHooksTemplate.categoryType,
        selectedId: RandomId$ReactHooksTemplate.generate(),
        nameInvalid: false,
        showPreview: false,
        showSurveyNameInput: false,
        showAddQuestions: false,
        logicalJumpGroup: LogicalJump$ReactHooksTemplate.makeGroup(),
        builderPreview: "Empty",
        graph: LogicGraph$ReactHooksTemplate.empty(),
        client: OrganizationProfile$ReactHooksTemplate.empty(),
        language: SurveyLanguage$ReactHooksTemplate.default,
        surveyLanguages: /* [] */0,
        notification: undefined,
        showConfigurations: false,
        outsideClick: true,
        showWelcome: true,
        showThankyou: true,
        addQuestionBelow: false,
        toBeAddedBelowIndex: 0,
        addThankYouToTop: false,
        selectedEditor: "QuestionsEditor",
        popUp: undefined,
        bulkTriggerToken: undefined,
        showTokenModal: false,
        paginationSettings: {
          TAG: "Uniform",
          _0: 1
        },
        paginationReset: false
      });
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        return "Loading";
      });
  var setMode = match$1[1];
  var match$2 = React.useState(function (param) {
        return true;
      });
  var setViewQuestion = match$2[1];
  var viewQuestion = match$2[0];
  var match$3 = React.useState(function (param) {
        return "";
      });
  var setSidebarSearch = match$3[1];
  var sidebarSearch = match$3[0];
  var match$4 = React.useState(function (param) {
        return "";
      });
  var setAddQuestionSearch = match$4[1];
  var addQuestionSearch = match$4[0];
  var match$5 = React.useState(function (param) {
        return false;
      });
  var setViewLogic = match$5[1];
  var viewLogic = match$5[0];
  var saveForm = function (survey) {
    var params = {};
    params["survey"] = Survey$ReactHooksTemplate.toJson(survey);
    var id = Survey$ReactHooksTemplate.id(survey);
    var tmp;
    if (id !== undefined) {
      var surveyId = String(id);
      tmp = Http$ReactHooksTemplate.fetchPostJSON("/api/v1/surveys/" + surveyId + "/update", params);
    } else {
      tmp = Http$ReactHooksTemplate.fetchPostJSON("/api/v1/surveys", params);
    }
    return Js_promise.then_((function (response) {
                  var status = Json_decode.field("status", (function (param) {
                          return Json_decode.withDefault("failed", Json_decode.string, param);
                        }), response);
                  if (status === "success") {
                    var survey = Json_decode.field("survey", Survey$ReactHooksTemplate.fromJson, response);
                    Curry._1(dispatch, {
                          TAG: "UpdateSurvey",
                          _0: survey
                        });
                    if (state.selectedEditor === "QuestionsEditor") {
                      Curry._1(dispatch, {
                            TAG: "AddNotification",
                            _0: {
                              TAG: "Success",
                              _0: "Updated the survey"
                            }
                          });
                    } else {
                      Curry._1(dispatch, {
                            TAG: "AddNotification",
                            _0: {
                              TAG: "Success",
                              _0: "Updated the Logic"
                            }
                          });
                    }
                    Curry._1(dispatch, {
                          TAG: "UpdateBuilderPreview",
                          _0: survey
                        });
                  } else {
                    Curry._1(dispatch, {
                          TAG: "AddNotification",
                          _0: {
                            TAG: "Failure",
                            _0: "Something went wrong. Please contact admin"
                          }
                        });
                  }
                  return Promise.resolve();
                }), tmp);
  };
  React.useEffect((function (param) {
          Js_promise.then_((function (organization) {
                  Curry._1(dispatch, {
                        TAG: "SetClient",
                        _0: organization
                      });
                  return Promise.resolve(Curry._1(setMode, (function (param) {
                                    return "Ready";
                                  })));
                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/organization_profiles/0", (function (param) {
                      return Json_decode.field("organization_profile", OrganizationProfile$ReactHooksTemplate.decode, param);
                    })));
        }), []);
  var handleSaveForm = function ($$event) {
    $$event.preventDefault();
    if (Survey$ReactHooksTemplate.name(state.survey).length === 0) {
      return Curry._1(dispatch, "InvalidName");
    } else {
      Curry._1(setMode, (function (param) {
              return "Saving";
            }));
      Js_promise.then_((function (param) {
              Curry._1(setMode, (function (param) {
                      return "Ready";
                    }));
              if (state.paginationReset) {
                Curry._1(dispatch, {
                      TAG: "SetPopUp",
                      _0: "PaginationReset"
                    });
              }
              return Promise.resolve();
            }), saveForm(state.survey));
      return ;
    }
  };
  var updateLogicInSurvey = function (survey) {
    Curry._1(dispatch, {
          TAG: "SetPopUp",
          _0: "SaveLogic"
        });
    Curry._1(dispatch, {
          TAG: "UpdateSurvey",
          _0: survey
        });
  };
  var toggleEditor = function (param) {
    var match = state.selectedEditor;
    switch (match) {
      case "QuestionsEditor" :
          return Curry._1(dispatch, {
                      TAG: "SetSelectedEditor",
                      _0: "LogicEditor"
                    });
      case "LogicEditor" :
      case "TranslationsEditor" :
          return Curry._1(dispatch, {
                      TAG: "SetSelectedEditor",
                      _0: "QuestionsEditor"
                    });
      
    }
  };
  var saveSurveyPopUp = function (message, saveButtonText, handleClose, handleSave) {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: message
                                  }),
                              className: "p-8 text-lg font-bold flex justify-center items-center"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx("p", {
                                                  children: "Cancel"
                                                }),
                                            className: "text-darkcharcoal hover:text-pigmentblue"
                                          }),
                                      className: "bg-ghostwhite border border-gray-400 cursor-pointer\n                  flex justify-center items-center rounded p-2 text-sm hover:border-pigmentblue w-3/12",
                                      onClick: (function (param) {
                                          Curry._1(handleClose, undefined);
                                        })
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx("p", {
                                                  children: saveButtonText
                                                }),
                                            className: "text-white"
                                          }),
                                      className: "bg-pigmentblue border border-gray-400 cursor-pointer flex justify-center items-center rounded p-2 text-sm hover:bg-cetaceanblue w-3/12",
                                      onClick: Curry.__1(handleSave)
                                    })
                              ],
                              className: "p-8 flex gap-3 absolute bottom-0 w-full justify-end"
                            })
                      ],
                      className: "bg-white z-10 shadow relative border border-gray-300 rounded-lg h-200-px w-5/12"
                    }),
                className: "w-screen z-10 disabled-wrapper absolute inset-0 flex justify-center items-center",
                style: {
                  height: "calc(100vh + 5rem)"
                }
              });
  };
  var handleThankYouDeletion = function (index, thankYou) {
    var logics = Logic$ReactHooksTemplate.getThankYouAssociatedLogic(thankYou, Survey$ReactHooksTemplate.logics(state.survey));
    if (List.length(logics) !== 0) {
      return Curry._1(dispatch, {
                  TAG: "SetPopUp",
                  _0: {
                    TAG: "DeleteThankYou",
                    _0: index,
                    _1: thankYou,
                    _2: logics
                  }
                });
    } else {
      return Curry._1(dispatch, {
                  TAG: "RemoveThankYouEditorBlock",
                  _0: index,
                  _1: thankYou,
                  _2: logics
                });
    }
  };
  var handleQuestionDeletion = function (index, question) {
    var logics = Logic$ReactHooksTemplate.questionInLogic(Survey$ReactHooksTemplate.logics(state.survey), question);
    var match = Survey$ReactHooksTemplate.paginationSettings(state.survey);
    var isResetPagination = match !== undefined && typeof match !== "object" && match !== "SinglePage" ? true : false;
    if (List.length(logics) !== 0) {
      return Curry._1(dispatch, {
                  TAG: "SetPopUp",
                  _0: {
                    TAG: "DeleteQuestion",
                    _0: index,
                    _1: question,
                    _2: logics
                  }
                });
    } else {
      Curry._1(dispatch, {
            TAG: "RemoveQuestionEditorBlock",
            _0: index,
            _1: question,
            _2: logics
          });
      if (isResetPagination) {
        Curry._1(dispatch, "ResetPagination");
      }
      return Curry._1(dispatch, {
                  TAG: "SetPopUp",
                  _0: "SaveQuestion"
                });
    }
  };
  var surveyLivePreview = function (param) {
    var match = state.builderPreview;
    var page;
    page = typeof match !== "object" || !(match.TAG === "QuestionPage" && match._1 === undefined) ? state.builderPreview : ({
          TAG: "ThankYou",
          _0: Belt_List.head(Survey$ReactHooksTemplate.thankYouList(state.survey))
        });
    return JsxRuntime.jsx(SurveyBuilderLivePreview$ReactHooksTemplate.make, {
                survey: state.survey,
                client: state.client,
                builderPage: page,
                questionTemplates: builderPreviewQuestionTemplates,
                languageSelected: state.language,
                surveyLanguages: state.surveyLanguages,
                onQuestionChange: (function (q) {
                    Curry._1(dispatch, {
                          TAG: "UpdateQuestion",
                          _0: q
                        });
                  }),
                onLanguageChange: (function (lang) {
                    Curry._1(dispatch, {
                          TAG: "ChangeLanguage",
                          _0: lang
                        });
                  })
              });
  };
  var addQuestionPage = function (questionOrPage) {
    switch (questionOrPage.TAG) {
      case "Welcome" :
          Curry._1(dispatch, {
                TAG: "AddEditorBlock",
                _0: 0,
                _1: questionOrPage
              });
          break;
      case "ThankYou" :
          if (state.addQuestionBelow) {
            Curry._1(dispatch, {
                  TAG: "AddEditorBlock",
                  _0: state.addThankYouToTop ? 0 : state.toBeAddedBelowIndex,
                  _1: questionOrPage
                });
          } else {
            Curry._1(dispatch, {
                  TAG: "AddEditorBlock",
                  _0: Belt_List.length(Survey$ReactHooksTemplate.thankYouList(state.survey)),
                  _1: questionOrPage
                });
          }
          break;
      case "Question" :
          if (state.addQuestionBelow) {
            Curry._1(dispatch, {
                  TAG: "AddEditorBlock",
                  _0: state.toBeAddedBelowIndex,
                  _1: questionOrPage
                });
          } else {
            Curry._1(dispatch, {
                  TAG: "AddEditorBlock",
                  _0: Belt_List.length(Survey$ReactHooksTemplate.questions(state.survey)),
                  _1: questionOrPage
                });
          }
          break;
      
    }
    Curry._1(dispatch, {
          TAG: "SetPopUp",
          _0: "SaveQuestion"
        });
  };
  var openAddQuestionBelowModal = function (index, isLastQuestion) {
    Curry._1(dispatch, {
          TAG: "SetOutsideClick",
          _0: true
        });
    Curry._1(dispatch, {
          TAG: "ShowWelcomeThankYou",
          _0: false,
          _1: isLastQuestion
        });
    Curry._1(dispatch, {
          TAG: "SetAddQuestionBelow",
          _0: true
        });
    Curry._1(dispatch, {
          TAG: "SetAddThankYouToTop",
          _0: isLastQuestion
        });
    Curry._1(dispatch, {
          TAG: "SetToBeAddedBelowIndex",
          _0: index
        });
    Curry._1(dispatch, {
          TAG: "SetShowAddQuestions",
          _0: true
        });
    Curry._1(dispatch, {
          TAG: "SetPopUp",
          _0: "SaveQuestion"
        });
  };
  var makePageActions = function (canAddBelow, canDuplicate, canDelete, onAddBelow, onDuplicate, onDelete) {
    return {
            canAddBelow: canAddBelow,
            canDuplicate: canDuplicate,
            canDelete: canDelete,
            onAddBelow: onAddBelow,
            onDuplicate: onDuplicate,
            onDelete: onDelete
          };
  };
  var getSelectedThankYou = function (param) {
    var __x = Survey$ReactHooksTemplate.thankYouList(state.survey);
    var fromList = Belt_List.head(Belt_List.keep(__x, (function (thankYou) {
                return Caml_obj.equal(ThankYou$ReactHooksTemplate.uuid(thankYou), state.selectedId);
              })));
    if (fromList !== undefined) {
      return Caml_option.some(Caml_option.valFromOption(fromList));
    } else if (state.selected === ThankYou$ReactHooksTemplate.categoryType) {
      return Belt_List.head(Survey$ReactHooksTemplate.thankYouList(state.survey));
    } else {
      return ;
    }
  };
  var getSelectedQuestion = function (param) {
    var __x = Survey$ReactHooksTemplate.questions(state.survey);
    return Belt_List.head(Belt_List.keep(__x, (function (question) {
                      return Caml_obj.equal(Question$ReactHooksTemplate.uuid(question), state.selectedId);
                    })));
  };
  var questionsModal = function (showWelcome, showThankYou) {
    if (!state.showAddQuestions) {
      return null;
    }
    var match = Survey$ReactHooksTemplate.category(state.survey);
    var frequentlyUsed;
    frequentlyUsed = match === "Normal" ? [
        [
          Image$ReactHooksTemplate.welcomeThankyou,
          "Welcome page",
          (function (param) {
              var questionOrPage = {
                TAG: "Welcome",
                _0: Welcome$ReactHooksTemplate.empty()
              };
              addQuestionPage(questionOrPage);
              Curry._1(setAddQuestionSearch, (function (param) {
                      return "";
                    }));
              Curry._1(dispatch, {
                    TAG: "SetShowAddQuestions",
                    _0: false
                  });
            }),
          !showWelcome
        ],
        [
          Image$ReactHooksTemplate.opinionScale,
          "NPS",
          (function (param) {
              var questionOrPage = {
                TAG: "Question",
                _0: Question$ReactHooksTemplate.empty(Nps$ReactHooksTemplate.categoryType)
              };
              addQuestionPage(questionOrPage);
              Curry._1(setAddQuestionSearch, (function (param) {
                      return "";
                    }));
              Curry._1(dispatch, {
                    TAG: "SetShowAddQuestions",
                    _0: false
                  });
            }),
          false
        ],
        [
          Image$ReactHooksTemplate.radioButtonChecked,
          "Multiple Choice",
          (function (param) {
              var questionOrPage = {
                TAG: "Question",
                _0: Question$ReactHooksTemplate.empty(MultipleChoice$ReactHooksTemplate.categoryType)
              };
              addQuestionPage(questionOrPage);
              Curry._1(setAddQuestionSearch, (function (param) {
                      return "";
                    }));
              Curry._1(dispatch, {
                    TAG: "SetShowAddQuestions",
                    _0: false
                  });
            }),
          false
        ],
        [
          Image$ReactHooksTemplate.shortText,
          "Short Text",
          (function (param) {
              var questionOrPage = {
                TAG: "Question",
                _0: Question$ReactHooksTemplate.empty(ShortText$ReactHooksTemplate.categoryType)
              };
              addQuestionPage(questionOrPage);
              Curry._1(setAddQuestionSearch, (function (param) {
                      return "";
                    }));
              Curry._1(dispatch, {
                    TAG: "SetShowAddQuestions",
                    _0: false
                  });
            }),
          false
        ],
        [
          Image$ReactHooksTemplate.longText,
          "Long Text",
          (function (param) {
              var questionOrPage = {
                TAG: "Question",
                _0: Question$ReactHooksTemplate.empty(LongText$ReactHooksTemplate.categoryType)
              };
              addQuestionPage(questionOrPage);
              Curry._1(setAddQuestionSearch, (function (param) {
                      return "";
                    }));
              Curry._1(dispatch, {
                    TAG: "SetShowAddQuestions",
                    _0: false
                  });
            }),
          false
        ],
        [
          Image$ReactHooksTemplate.rating,
          "Star Rating",
          (function (param) {
              var questionOrPage = {
                TAG: "Question",
                _0: Question$ReactHooksTemplate.empty(StarRating$ReactHooksTemplate.categoryType)
              };
              addQuestionPage(questionOrPage);
              Curry._1(setAddQuestionSearch, (function (param) {
                      return "";
                    }));
              Curry._1(dispatch, {
                    TAG: "SetShowAddQuestions",
                    _0: false
                  });
            }),
          false
        ],
        [
          Image$ReactHooksTemplate.welcomeThankyou,
          "Thank you page",
          (function (param) {
              var questionOrPage = {
                TAG: "ThankYou",
                _0: ThankYou$ReactHooksTemplate.empty()
              };
              addQuestionPage(questionOrPage);
              Curry._1(setAddQuestionSearch, (function (param) {
                      return "";
                    }));
              Curry._1(dispatch, {
                    TAG: "SetShowAddQuestions",
                    _0: false
                  });
            }),
          !showThankYou
        ]
      ] : [
        [
          Image$ReactHooksTemplate.welcomeThankyou,
          "Welcome page",
          (function (param) {
              var questionOrPage = {
                TAG: "Welcome",
                _0: Welcome$ReactHooksTemplate.empty()
              };
              addQuestionPage(questionOrPage);
              Curry._1(setAddQuestionSearch, (function (param) {
                      return "";
                    }));
              Curry._1(dispatch, {
                    TAG: "SetShowAddQuestions",
                    _0: false
                  });
            }),
          !showWelcome
        ],
        [
          Image$ReactHooksTemplate.radioButtonChecked,
          "Multiple Select",
          (function (param) {
              var questionOrPage = {
                TAG: "Question",
                _0: Question$ReactHooksTemplate.empty(MultipleSelect$ReactHooksTemplate.categoryType)
              };
              addQuestionPage(questionOrPage);
              Curry._1(setAddQuestionSearch, (function (param) {
                      return "";
                    }));
              Curry._1(dispatch, {
                    TAG: "SetShowAddQuestions",
                    _0: false
                  });
            }),
          false
        ],
        [
          Image$ReactHooksTemplate.welcomeThankyou,
          "Thank you page",
          (function (param) {
              var questionOrPage = {
                TAG: "ThankYou",
                _0: ThankYou$ReactHooksTemplate.empty()
              };
              addQuestionPage(questionOrPage);
              Curry._1(setAddQuestionSearch, (function (param) {
                      return "";
                    }));
              Curry._1(dispatch, {
                    TAG: "SetShowAddQuestions",
                    _0: false
                  });
            }),
          !showThankYou
        ]
      ];
    var match$1 = Survey$ReactHooksTemplate.category(state.survey);
    var others;
    others = match$1 === "Normal" ? [
        [
          Image$ReactHooksTemplate.rating,
          "Rating Group",
          (function (param) {
              var questionOrPage = {
                TAG: "Question",
                _0: Question$ReactHooksTemplate.empty(RatingGroup$ReactHooksTemplate.categoryType)
              };
              addQuestionPage(questionOrPage);
              Curry._1(setAddQuestionSearch, (function (param) {
                      return "";
                    }));
              Curry._1(dispatch, {
                    TAG: "SetShowAddQuestions",
                    _0: false
                  });
            }),
          false
        ],
        [
          Image$ReactHooksTemplate.opinionScale,
          "Opinion Scale",
          (function (param) {
              var questionOrPage = {
                TAG: "Question",
                _0: Question$ReactHooksTemplate.empty(OpinionScale$ReactHooksTemplate.categoryType)
              };
              addQuestionPage(questionOrPage);
              Curry._1(setAddQuestionSearch, (function (param) {
                      return "";
                    }));
              Curry._1(dispatch, {
                    TAG: "SetShowAddQuestions",
                    _0: false
                  });
            }),
          false
        ],
        [
          Image$ReactHooksTemplate.rating,
          "Smiley Rating",
          (function (param) {
              var questionOrPage = {
                TAG: "Question",
                _0: Question$ReactHooksTemplate.empty(SmileyRating$ReactHooksTemplate.categoryType)
              };
              addQuestionPage(questionOrPage);
              Curry._1(setAddQuestionSearch, (function (param) {
                      return "";
                    }));
              Curry._1(dispatch, {
                    TAG: "SetShowAddQuestions",
                    _0: false
                  });
            }),
          false
        ],
        [
          Image$ReactHooksTemplate.defaultQuestion,
          "CSAT",
          (function (param) {
              var questionOrPage = {
                TAG: "Question",
                _0: Question$ReactHooksTemplate.empty(Csat$ReactHooksTemplate.categoryType)
              };
              addQuestionPage(questionOrPage);
              Curry._1(setAddQuestionSearch, (function (param) {
                      return "";
                    }));
              Curry._1(dispatch, {
                    TAG: "SetShowAddQuestions",
                    _0: false
                  });
            }),
          false
        ],
        [
          Image$ReactHooksTemplate.radioButtonChecked,
          "Multiple Select",
          (function (param) {
              var questionOrPage = {
                TAG: "Question",
                _0: Question$ReactHooksTemplate.empty(MultipleSelect$ReactHooksTemplate.categoryType)
              };
              addQuestionPage(questionOrPage);
              Curry._1(setAddQuestionSearch, (function (param) {
                      return "";
                    }));
              Curry._1(dispatch, {
                    TAG: "SetShowAddQuestions",
                    _0: false
                  });
            }),
          false
        ],
        [
          Image$ReactHooksTemplate.defaultQuestion,
          "Drop Down",
          (function (param) {
              var questionOrPage = {
                TAG: "Question",
                _0: Question$ReactHooksTemplate.empty(DropDown$ReactHooksTemplate.categoryType)
              };
              addQuestionPage(questionOrPage);
              Curry._1(setAddQuestionSearch, (function (param) {
                      return "";
                    }));
              Curry._1(dispatch, {
                    TAG: "SetShowAddQuestions",
                    _0: false
                  });
            }),
          false
        ],
        [
          Image$ReactHooksTemplate.shortText,
          "MobileNumber",
          (function (param) {
              var questionOrPage = {
                TAG: "Question",
                _0: Question$ReactHooksTemplate.empty(MobileNumber$ReactHooksTemplate.categoryType)
              };
              addQuestionPage(questionOrPage);
              Curry._1(setAddQuestionSearch, (function (param) {
                      return "";
                    }));
              Curry._1(dispatch, {
                    TAG: "SetShowAddQuestions",
                    _0: false
                  });
            }),
          false
        ]
      ] : [];
    var matches = function (param) {
      return Utils$ReactHooksTemplate.matchesSearchQuery(addQuestionSearch, param[1]);
    };
    var renderCard = function (param) {
      var onSelect = param[2];
      var label = param[1];
      return JsxRuntime.jsxs("button", {
                  children: [
                    JsxRuntime.jsx("img", {
                          className: "sb-qtype-card-icon",
                          src: param[0]
                        }),
                    JsxRuntime.jsx("span", {
                          children: label,
                          className: "sb-qtype-card-label"
                        })
                  ],
                  className: "sb-qtype-card " + (
                    param[3] ? "sb-qtype-card--disabled" : ""
                  ),
                  type: "button",
                  onClick: (function (param) {
                      Curry._1(onSelect, undefined);
                    })
                }, label);
    };
    var renderGroup = function (title, items) {
      var shown = Belt_Array.keep(items, matches);
      if (shown.length !== 0) {
        return JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: title,
                            className: "sb-qtype-group-title"
                          }),
                      JsxRuntime.jsx("div", {
                            children: Belt_Array.map(shown, renderCard),
                            className: "sb-qtype-grid"
                          })
                    ],
                    className: "sb-qtype-group"
                  });
      } else {
        return null;
      }
    };
    var hasResults = (Belt_Array.keep(frequentlyUsed, matches).length + Belt_Array.keep(others, matches).length | 0) > 0;
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("p", {
                                      children: "Choose a question",
                                      className: "sb-choose-modal-title"
                                    }),
                                JsxRuntime.jsx("button", {
                                      children: JsxRuntime.jsx("img", {
                                            className: "h-12-px",
                                            src: Image$ReactHooksTemplate.closeIcon
                                          }),
                                      "aria-label": "Close",
                                      className: "sb-choose-modal-close",
                                      type: "button",
                                      onClick: (function (param) {
                                          Curry._1(setAddQuestionSearch, (function (param) {
                                                  return "";
                                                }));
                                          Curry._1(dispatch, {
                                                TAG: "SetShowAddQuestions",
                                                _0: false
                                              });
                                        })
                                    })
                              ],
                              className: "sb-choose-modal-header"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("img", {
                                      className: "sb-choose-search-icon",
                                      src: Image$ReactHooksTemplate.search
                                    }),
                                JsxRuntime.jsx("input", {
                                      className: "sb-choose-search-input",
                                      placeholder: "Search Question Types",
                                      type: "text",
                                      value: addQuestionSearch,
                                      onChange: (function (e) {
                                          var value = e.target.value;
                                          Curry._1(setAddQuestionSearch, (function (param) {
                                                  return value;
                                                }));
                                        })
                                    })
                              ],
                              className: "sb-choose-modal-search"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                renderGroup("Frequently used", frequentlyUsed),
                                renderGroup("Others", others),
                                hasResults ? null : JsxRuntime.jsx("div", {
                                        children: "No question types match your search.",
                                        className: "sb-qtype-empty"
                                      })
                              ],
                              className: "sb-choose-modal-body"
                            })
                      ],
                      className: "sb-choose-modal",
                      onClick: (function ($$event) {
                          $$event.stopPropagation();
                        })
                    }),
                className: "sb-choose-modal-overlay",
                onClick: (function (param) {
                    Curry._1(setAddQuestionSearch, (function (param) {
                            return "";
                          }));
                    Curry._1(dispatch, {
                          TAG: "SetShowAddQuestions",
                          _0: false
                        });
                  })
              });
  };
  var match$6 = state.selectedEditor;
  var toolbarActiveTab;
  switch (match$6) {
    case "QuestionsEditor" :
        toolbarActiveTab = "Questions";
        break;
    case "LogicEditor" :
        toolbarActiveTab = "Logic";
        break;
    case "TranslationsEditor" :
        toolbarActiveTab = "Translations";
        break;
    
  }
  var handleToolbarTab = function (tab) {
    Curry._1(setAddQuestionSearch, (function (param) {
            return "";
          }));
    Curry._1(dispatch, {
          TAG: "SetShowAddQuestions",
          _0: false
        });
    switch (tab) {
      case "Questions" :
          Curry._1(setViewQuestion, (function (param) {
                  return true;
                }));
          Curry._1(setViewLogic, (function (param) {
                  return false;
                }));
          return Curry._1(dispatch, {
                      TAG: "SetSelectedEditor",
                      _0: "QuestionsEditor"
                    });
      case "Logic" :
          Curry._1(setViewLogic, (function (param) {
                  return true;
                }));
          Curry._1(setViewQuestion, (function (param) {
                  return false;
                }));
          return Curry._1(dispatch, {
                      TAG: "SetSelectedEditor",
                      _0: "LogicEditor"
                    });
      case "Translations" :
          Curry._1(setViewQuestion, (function (param) {
                  return false;
                }));
          Curry._1(setViewLogic, (function (param) {
                  return false;
                }));
          return Curry._1(dispatch, {
                      TAG: "SetSelectedEditor",
                      _0: "TranslationsEditor"
                    });
      
    }
  };
  var getCenterTitle = function (param) {
    if (state.selected === Welcome$ReactHooksTemplate.categoryType) {
      return "Edit Welcome Page";
    } else if (state.selected === ThankYou$ReactHooksTemplate.categoryType) {
      return "Edit Thank You Page";
    } else {
      return "Edit Question";
    }
  };
  var buildPageItems = function (param) {
    var welcome = Survey$ReactHooksTemplate.welcome(state.survey);
    var welcomeList;
    if (welcome !== undefined) {
      var plainTitle = Utils$ReactHooksTemplate.stripHtml(Welcome$ReactHooksTemplate.title(Caml_option.valFromOption(welcome))).trim();
      var label = plainTitle === "" ? "Welcome Page" : plainTitle;
      var typeLabel = formatQuestionTypeLabel(Welcome$ReactHooksTemplate.categoryType);
      welcomeList = {
        hd: {
          id: "welcome",
          label: label,
          typeLabel: typeLabel,
          searchText: plainTitle + " " + typeLabel + " " + Welcome$ReactHooksTemplate.categoryType,
          icon: questionTypeIcon(Welcome$ReactHooksTemplate.categoryType),
          isActive: state.selected === Welcome$ReactHooksTemplate.categoryType,
          onClick: (function (param) {
              Curry._1(dispatch, {
                    TAG: "SetSelected",
                    _0: Welcome$ReactHooksTemplate.categoryType
                  });
              Curry._1(dispatch, "PreviewWelcome");
            }),
          actions: makePageActions(true, false, true, (function (param) {
                  openAddQuestionBelowModal(0, Belt_List.length(Survey$ReactHooksTemplate.questions(state.survey)) === 0);
                }), (function (param) {
                  
                }), (function (param) {
                  Curry._1(dispatch, {
                        TAG: "SetOutsideClick",
                        _0: true
                      });
                  Curry._1(dispatch, "RemoveWelcomeEditorBlock");
                  Curry._1(dispatch, {
                        TAG: "SetPopUp",
                        _0: "SaveQuestion"
                      });
                }))
        },
        tl: /* [] */0
      };
    } else {
      welcomeList = /* [] */0;
    }
    var questionItems = List.mapi((function (index, question) {
            var categoryType = Question$ReactHooksTemplate.categoryType(question);
            var plainText = Utils$ReactHooksTemplate.stripHtml(Question$ReactHooksTemplate.text(question)).trim();
            var typeLabel = formatQuestionTypeLabel(categoryType);
            var label = plainText === "" ? typeLabel : plainText;
            var questionsLength = Belt_List.length(Survey$ReactHooksTemplate.questions(state.survey));
            var isLastQuestion = (index + 1 | 0) === questionsLength;
            return {
                    id: RandomId$ReactHooksTemplate.toString(Question$ReactHooksTemplate.uuid(question)),
                    label: label,
                    typeLabel: typeLabel,
                    searchText: plainText + " " + typeLabel + " " + categoryType,
                    icon: questionTypeIcon(categoryType),
                    isActive: state.selected === categoryType && Caml_obj.equal(state.selectedId, Question$ReactHooksTemplate.uuid(question)),
                    onClick: (function (param) {
                        Curry._1(dispatch, {
                              TAG: "SetSelected",
                              _0: categoryType
                            });
                        Curry._1(dispatch, {
                              TAG: "SetSelectedId",
                              _0: Question$ReactHooksTemplate.uuid(question)
                            });
                        Curry._1(dispatch, {
                              TAG: "PreviewQuestion",
                              _0: question
                            });
                      }),
                    actions: makePageActions(true, true, true, (function (param) {
                            openAddQuestionBelowModal(index + 1 | 0, isLastQuestion);
                          }), (function (param) {
                            Curry._1(dispatch, {
                                  TAG: "SetOutsideClick",
                                  _0: true
                                });
                            Curry._1(dispatch, {
                                  TAG: "AddEditorBlock",
                                  _0: index + 1 | 0,
                                  _1: {
                                    TAG: "Question",
                                    _0: Question$ReactHooksTemplate.duplicate(question)
                                  }
                                });
                          }), (function (param) {
                            handleQuestionDeletion(index, question);
                            Curry._1(dispatch, {
                                  TAG: "SetOutsideClick",
                                  _0: true
                                });
                          }))
                  };
          }), Survey$ReactHooksTemplate.questions(state.survey));
    var thankYouItems = List.mapi((function (index, thankYou) {
            var plainText = Utils$ReactHooksTemplate.stripHtml(ThankYou$ReactHooksTemplate.text(thankYou)).trim();
            var typeLabel = formatQuestionTypeLabel(ThankYou$ReactHooksTemplate.categoryType);
            var label = plainText === "" ? "Thank You" : plainText;
            return {
                    id: RandomId$ReactHooksTemplate.toString(ThankYou$ReactHooksTemplate.uuid(thankYou)),
                    label: label,
                    typeLabel: typeLabel,
                    searchText: plainText + " " + typeLabel + " " + ThankYou$ReactHooksTemplate.categoryType,
                    icon: questionTypeIcon(ThankYou$ReactHooksTemplate.categoryType),
                    isActive: state.selected === ThankYou$ReactHooksTemplate.categoryType && Caml_obj.equal(state.selectedId, ThankYou$ReactHooksTemplate.uuid(thankYou)),
                    onClick: (function (param) {
                        Curry._1(dispatch, {
                              TAG: "SetSelected",
                              _0: ThankYou$ReactHooksTemplate.categoryType
                            });
                        Curry._1(dispatch, {
                              TAG: "SetSelectedId",
                              _0: ThankYou$ReactHooksTemplate.uuid(thankYou)
                            });
                        Curry._1(dispatch, {
                              TAG: "PreviewThankYou",
                              _0: thankYou
                            });
                      }),
                    actions: makePageActions(true, true, true, (function (param) {
                            Curry._1(dispatch, {
                                  TAG: "SetOutsideClick",
                                  _0: true
                                });
                            Curry._1(dispatch, {
                                  TAG: "AddEditorBlock",
                                  _0: index + 1 | 0,
                                  _1: {
                                    TAG: "ThankYou",
                                    _0: ThankYou$ReactHooksTemplate.empty()
                                  }
                                });
                            Curry._1(dispatch, {
                                  TAG: "SetPopUp",
                                  _0: "SaveQuestion"
                                });
                          }), (function (param) {
                            Curry._1(dispatch, {
                                  TAG: "SetOutsideClick",
                                  _0: true
                                });
                            Curry._1(dispatch, {
                                  TAG: "AddEditorBlock",
                                  _0: index + 1 | 0,
                                  _1: {
                                    TAG: "ThankYou",
                                    _0: ThankYou$ReactHooksTemplate.duplicate(thankYou)
                                  }
                                });
                          }), (function (param) {
                            handleThankYouDeletion(index, thankYou);
                            Curry._1(dispatch, {
                                  TAG: "SetOutsideClick",
                                  _0: true
                                });
                          }))
                  };
          }), Survey$ReactHooksTemplate.thankYouList(state.survey));
    var __x = Belt_List.toArray(Belt_List.concat(welcomeList, Belt_List.concat(questionItems, thankYouItems)));
    return Belt_Array.keep(__x, (function (item) {
                  return Utils$ReactHooksTemplate.matchesSearchQuery(sidebarSearch, item.searchText);
                }));
  };
  var thankYou = getSelectedThankYou();
  var centerThankYouEditor = thankYou !== undefined ? JsxRuntime.jsx(ThankYouPageEditorCard$ReactHooksTemplate.make, {
          thankYou: Caml_option.valFromOption(thankYou),
          onThankYouChange: (function (t) {
              Curry._1(dispatch, {
                    TAG: "UpdateThankYou",
                    _0: t
                  });
            })
        }) : null;
  var question = getSelectedQuestion();
  var centerQuestionEditor;
  if (question !== undefined) {
    var match$7 = Survey$ReactHooksTemplate.category(state.survey);
    var isQuizMode;
    isQuizMode = match$7 === "Normal" ? false : true;
    centerQuestionEditor = JsxRuntime.jsx(QuestionPageEditorCard$ReactHooksTemplate.make, {
          question: question,
          onQuestionChange: (function (q) {
              Curry._1(dispatch, {
                    TAG: "UpdateQuestion",
                    _0: q
                  });
            }),
          quizMode: isQuizMode
        });
  } else {
    centerQuestionEditor = null;
  }
  var welcome = Survey$ReactHooksTemplate.welcome(state.survey);
  var centerWelcomeEditor = welcome !== undefined ? JsxRuntime.jsx(WelcomePageEditorCard$ReactHooksTemplate.make, {
          welcome: Caml_option.valFromOption(welcome),
          onWelcomeChange: (function (w) {
              Curry._1(dispatch, {
                    TAG: "UpdateWelcome",
                    _0: w
                  });
            })
        }) : null;
  var questionEditor = JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(SurveyBuilderTypeSidebar$ReactHooksTemplate.make, {
                pageItems: buildPageItems(),
                onAddQuestion: (function (param) {
                    Curry._1(dispatch, {
                          TAG: "SetAddQuestionBelow",
                          _0: false
                        });
                    Curry._1(dispatch, {
                          TAG: "SetAddThankYouToTop",
                          _0: false
                        });
                    Curry._1(dispatch, {
                          TAG: "SetShowAddQuestions",
                          _0: true
                        });
                  }),
                searchQuery: sidebarSearch,
                onSearchChange: (function (query) {
                    Curry._1(setSidebarSearch, (function (param) {
                            return query;
                          }));
                  })
              }),
          JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("img", {
                                        className: "sb-center-title-icon",
                                        src: Image$ReactHooksTemplate.edit
                                      }),
                                  getCenterTitle()
                                ],
                                className: "sb-center-title"
                              }),
                          JsxRuntime.jsxs("span", {
                                children: [
                                  JsxRuntime.jsx("span", {
                                        className: "sb-badge-dot"
                                      }),
                                  "Editing Active"
                                ],
                                className: "sb-badge-editing"
                              })
                        ],
                        className: "sb-center-header"
                      }),
                  state.selected === Welcome$ReactHooksTemplate.categoryType ? centerWelcomeEditor : (
                      state.selected === ThankYou$ReactHooksTemplate.categoryType ? centerThankYouEditor : centerQuestionEditor
                    )
                ],
                className: "sb-center",
                onClick: (function (param) {
                    Curry._1(dispatch, {
                          TAG: "SetOutsideClick",
                          _0: true
                        });
                    Curry._1(dispatch, {
                          TAG: "SetPopUp",
                          _0: "SaveQuestion"
                        });
                  })
              }),
          JsxRuntime.jsx(SurveyBuilderSettingsShell$ReactHooksTemplate.make, {
                preview: surveyLivePreview()
              })
        ],
        className: "sb-body"
      });
  var logicEditor = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(LogicPage$ReactHooksTemplate.make, {
                    survey: state.survey,
                    updateSurvey: updateLogicInSurvey
                  }),
              className: "sb-center",
              style: {
                width: "100%"
              }
            }),
        className: "sb-body"
      });
  var surveyId = Survey$ReactHooksTemplate.id(state.survey);
  var translationsEditor = surveyId !== undefined ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(SurveyTranslations$ReactHooksTemplate.make, {
                      surveyId: surveyId,
                      onLanguageSelectorPositionChange: (function (position) {
                          var updatedSurvey = Survey$ReactHooksTemplate.setLanguageSelectorPosition(state.survey, position);
                          Curry._1(dispatch, {
                                TAG: "UpdateSurvey",
                                _0: updatedSurvey
                              });
                          Curry._1(dispatch, {
                                TAG: "UpdateBuilderPreview",
                                _0: updatedSurvey
                              });
                        })
                    }),
                className: "sb-center survey-translations-editor-panel",
                style: {
                  width: "100%"
                }
              }),
          className: "sb-body"
        }) : JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
                children: "Save the survey before managing translations.",
                className: "sb-center p-8 text-sm text-darkcharcoal"
              }),
          className: "sb-body"
        });
  var selectedEditor = function (param) {
    var match = state.selectedEditor;
    switch (match) {
      case "QuestionsEditor" :
          return questionEditor;
      case "LogicEditor" :
          return logicEditor;
      case "TranslationsEditor" :
          return translationsEditor;
      
    }
  };
  var match$8 = state.popUp;
  var handlePopUpDisplay;
  if (match$8 !== undefined) {
    if (typeof match$8 !== "object") {
      switch (match$8) {
        case "SaveQuestion" :
            handlePopUpDisplay = viewLogic && !viewQuestion ? saveSurveyPopUp("Kindly save questions before switching", "Save", (function (param) {
                      Curry._1(setViewLogic, (function (param) {
                              return !viewLogic;
                            }));
                      Curry._1(setViewQuestion, (function (param) {
                              return !viewQuestion;
                            }));
                    }), (function ($$event) {
                      toggleEditor();
                      handleSaveForm($$event);
                      Curry._1(dispatch, {
                            TAG: "SetPopUp",
                            _0: undefined
                          });
                    })) : selectedEditor();
            break;
        case "SaveLogic" :
            handlePopUpDisplay = viewLogic || !viewQuestion ? selectedEditor() : saveSurveyPopUp("Kindly save logics before switching", "Save", (function (param) {
                      Curry._1(setViewLogic, (function (param) {
                              return !viewLogic;
                            }));
                      Curry._1(setViewQuestion, (function (param) {
                              return !viewQuestion;
                            }));
                    }), (function ($$event) {
                      toggleEditor();
                      handleSaveForm($$event);
                      Curry._1(dispatch, {
                            TAG: "SetPopUp",
                            _0: undefined
                          });
                    }));
            break;
        case "PaginationReset" :
            handlePopUpDisplay = JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx("div", {
                                      children: "Pagination has been reset to uniform due to question changes. \n            This can be updated again in Configuration settings."
                                    }),
                                className: "p-8 text-lg font-bold flex justify-center items-center text-center"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx("p", {
                                                  children: "OK"
                                                }),
                                            className: "text-white"
                                          }),
                                      className: "bg-pigmentblue border border-gray-400 cursor-pointer\n                    flex justify-center items-center rounded p-2 text-sm hover:bg-cetaceanblue w-3/12",
                                      onClick: (function (param) {
                                          Curry._1(dispatch, {
                                                TAG: "SetPopUp",
                                                _0: undefined
                                              });
                                        })
                                    }),
                                className: "p-8 flex gap-3 absolute bottom-0 w-full justify-center"
                              })
                        ],
                        className: "bg-white z-10 shadow relative border border-gray-300 rounded-lg h-200-px w-5/12"
                      }),
                  className: "w-screen z-10 disabled-wrapper absolute inset-0 flex justify-center items-center",
                  style: {
                    height: "calc(100vh + 5rem)"
                  }
                });
            break;
        
      }
    } else if (match$8.TAG === "DeleteQuestion") {
      var logics = match$8._2;
      var question$1 = match$8._1;
      var index = match$8._0;
      handlePopUpDisplay = saveSurveyPopUp("Deleting this question will also remove all associated logic. Please confirm.", "Delete", (function (param) {
              if (state.popUp === undefined) {
                return Curry._1(dispatch, {
                            TAG: "SetPopUp",
                            _0: undefined
                          });
              } else {
                return Curry._1(dispatch, {
                            TAG: "SetPopUp",
                            _0: "SaveQuestion"
                          });
              }
            }), (function (param) {
              Curry._1(dispatch, {
                    TAG: "RemoveQuestionEditorBlock",
                    _0: index,
                    _1: question$1,
                    _2: logics
                  });
              Curry._1(dispatch, {
                    TAG: "SetPopUp",
                    _0: "SaveQuestion"
                  });
            }));
    } else {
      var logics$1 = match$8._2;
      var thankYou$1 = match$8._1;
      var index$1 = match$8._0;
      handlePopUpDisplay = saveSurveyPopUp("Deleting the thankyou will also remove all the associated logic. Please confirm.", "Delete", (function (param) {
              if (state.popUp === undefined) {
                return Curry._1(dispatch, {
                            TAG: "SetPopUp",
                            _0: undefined
                          });
              } else {
                return Curry._1(dispatch, {
                            TAG: "SetPopUp",
                            _0: "SaveQuestion"
                          });
              }
            }), (function (param) {
              Curry._1(dispatch, {
                    TAG: "RemoveThankYouEditorBlock",
                    _0: index$1,
                    _1: thankYou$1,
                    _2: logics$1
                  });
              Curry._1(dispatch, {
                    TAG: "SetPopUp",
                    _0: "SaveQuestion"
                  });
            }));
    }
  } else {
    handlePopUpDisplay = selectedEditor();
  }
  var match$9 = state.selectedEditor;
  var renderEditor;
  switch (match$9) {
    case "QuestionsEditor" :
    case "LogicEditor" :
        renderEditor = handlePopUpDisplay;
        break;
    case "TranslationsEditor" :
        renderEditor = translationsEditor;
        break;
    
  }
  var fetchBulkTriggerToken = function (surveyId) {
    var url = "/api/v1/projects/" + String(projectId) + "/surveys/" + String(surveyId) + "/bulk_trigger_token";
    return Js_promise.then_((function (json) {
                  return Promise.resolve(Json_decode.field("token", Json_decode.string, json));
                }), Http$ReactHooksTemplate.fetchGetJSON(url));
  };
  var tokenModal = function (param) {
    var token = state.bulkTriggerToken;
    if (token !== undefined) {
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("h3", {
                                              children: "Bulk Trigger Token",
                                              className: "text-xl font-semibold text-gray-800"
                                            }),
                                        JsxRuntime.jsx("button", {
                                              children: JsxRuntime.jsx("svg", {
                                                    children: JsxRuntime.jsx("path", {
                                                          d: "M6 18L18 6M6 6l12 12",
                                                          strokeLinecap: "round",
                                                          strokeLinejoin: "round",
                                                          strokeWidth: "2"
                                                        }),
                                                    className: "h-6 w-6",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    viewBox: "0 0 24 24"
                                                  }),
                                              className: "text-gray-400 hover:text-gray-500 focus:outline-none",
                                              onClick: (function (param) {
                                                  Curry._1(dispatch, {
                                                        TAG: "SetShowTokenModal",
                                                        _0: false
                                                      });
                                                })
                                            })
                                      ],
                                      className: "flex justify-between items-center pb-4 border-b border-gray-200"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx("p", {
                                                  children: token,
                                                  className: "text-sm font-mono break-all text-gray-700"
                                                }),
                                            className: "bg-gray-50 p-4 rounded-lg border border-gray-200"
                                          }),
                                      className: "mt-6"
                                    })
                              ],
                              className: "flex flex-col"
                            }),
                        className: "relative p-6 border w-[32rem] shadow-xl rounded-lg bg-white"
                      }),
                  className: "fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center"
                });
    } else {
      return JsxRuntime.jsx(JsxRuntime.Fragment, {});
    }
  };
  switch (match$1[0]) {
    case "Loading" :
        return JsxRuntime.jsx("p", {
                    children: "Loading survey from API in progress..."
                  });
    case "Ready" :
        var alertType = state.notification;
        var surveyId$1 = Survey$ReactHooksTemplate.id(state.survey);
        return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      state.showPreview ? JsxRuntime.jsx(Modal$ReactHooksTemplate.make, {
                              show: true,
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx(SurveyPreviewWrapper$ReactHooksTemplate.make, {
                                                survey: state.survey,
                                                client: state.client
                                              }),
                                          className: ""
                                        }),
                                    className: "w-screen bg-white pt-6"
                                  }),
                              handleClose: (function (param) {
                                  Curry._1(dispatch, "TogglePreview");
                                })
                            }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                      state.showConfigurations ? JsxRuntime.jsx(SurveyConfiguration$ReactHooksTemplate.make, {
                              onClose: (function (param) {
                                  Curry._1(dispatch, "ToggleSurveyConfiguration");
                                }),
                              survey: state.survey,
                              updateSurvey: (function (survey) {
                                  Curry._1(dispatch, {
                                        TAG: "UpdateSurvey",
                                        _0: survey
                                      });
                                })
                            }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                      JsxRuntime.jsxs("div", {
                            children: [
                              alertType !== undefined ? JsxRuntime.jsx(AlertComponent$ReactHooksTemplate.make, {
                                      alertType: alertType,
                                      handleClose: (function (param) {
                                          Curry._1(dispatch, "RemoveNotification");
                                        })
                                    }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                              JsxRuntime.jsx(SurveyBuilderToolbar$ReactHooksTemplate.make, {
                                    surveyName: Survey$ReactHooksTemplate.name(state.survey),
                                    activeTab: toolbarActiveTab,
                                    onTabChange: handleToolbarTab,
                                    onSettingsClick: (function (param) {
                                        Curry._1(setAddQuestionSearch, (function (param) {
                                                return "";
                                              }));
                                        Curry._1(dispatch, {
                                              TAG: "SetShowAddQuestions",
                                              _0: false
                                            });
                                        Curry._1(dispatch, "ToggleSurveyConfiguration");
                                      }),
                                    onPreview: (function (param) {
                                        Curry._1(dispatch, "TogglePreview");
                                      }),
                                    onSave: (function ($$event) {
                                        Curry._1(dispatch, {
                                              TAG: "SetPopUp",
                                              _0: undefined
                                            });
                                        handleSaveForm($$event);
                                      }),
                                    onGetBulkTriggerToken: surveyId$1 !== undefined ? (function (param) {
                                          Js_promise.then_((function (token) {
                                                  Curry._1(dispatch, {
                                                        TAG: "SetBulkTriggerToken",
                                                        _0: token
                                                      });
                                                  Curry._1(dispatch, {
                                                        TAG: "SetShowTokenModal",
                                                        _0: true
                                                      });
                                                  return Promise.resolve();
                                                }), fetchBulkTriggerToken(surveyId$1));
                                        }) : undefined,
                                    projectId: projectId
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: renderEditor,
                                    className: "flex w-full flex-1 min-h-0"
                                  }),
                              questionsModal(state.showWelcome, state.showThankyou)
                            ],
                            className: "sb-root"
                          }),
                      state.showTokenModal ? tokenModal() : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                    ]
                  });
    case "Saving" :
        return JsxRuntime.jsx("p", {
                    children: "Saving survey in progress..."
                  });
    
  }
}

var yesbankQuestiontemplate = "\n  <div class=\"flex flex-col h-full min-h-screen\">\n    <div class=\"h-80-px small:h-60-px mb-5 small:mb-6 bg-cobalt\">\n      <div id=\"logo\">\n        logo\n      </div>\n    </div>\n    <div class=\"mx-12 small:mx-4 flex flex-col\">\n      <div id=\"language\">language</div>\n      <div class=\"pl-142-px small:pl-4 pr-80-px small:pr-4 pt-24 small:pt-4 question-box-gradient rounded-lg mb-8 flex-grow overflow-y-auto pb-16 small:pb-12\">\n        <div id=\"question\">question</div>\n      </div>\n    </div>\n    <div class=\"flex w-full justify-center items-center gap-4 mb-8\">\n      <div id=\"previousButton\"></div>\n      <div id=\"nextButton\"></div>\n    </div>\n  </div>";

var make = SurveyForm;

exports.yesbankQuestiontemplate = yesbankQuestiontemplate;
exports.bhimaQuestiontemplate = bhimaQuestiontemplate;
exports.defaultQuestiontemplate = defaultQuestiontemplate;
exports.defaultQuestionBuildertemplate = defaultQuestionBuildertemplate;
exports.questiontemplates = questiontemplates;
exports.builderPreviewQuestionTemplates = builderPreviewQuestionTemplates;
exports.questionBuilderTemplates = questionBuilderTemplates;
exports.formatQuestionTypeLabel = formatQuestionTypeLabel;
exports.questionTypeIcon = questionTypeIcon;
exports.decodeSurvey = decodeSurvey;
exports.addQuestionsToGraph = addQuestionsToGraph;
exports.reducer = reducer;
exports.make = make;
/* react Not a pure module */
